import api from "../api/client";

const budgetApi = {
  create(payload) {
    return api.post("/v1/pickup-budget", payload);
  },

 

  update(id, payload) {
    return api.patch(`/v1/pickup-budget/${id}`, payload);
  },
  
  getById(id) {  
    return api.get(`/v1/pickup-budget/${id}`);
  },

  getAll(params = {}) {
    return api.get("/v1/pickup-budget", { params });
  },

  delete(id) {
    return api.delete(`/v1/pickup-budget/${id}`);
  },

  getByClient(clientName) {
    return api.get("/v1/pickup-budget", {
      params: { clientPaymentName: clientName },
    });
  },

  getByStatus(status) {
    return api.get("/v1/pickup-budget", {
      params: { status },
    });
  },
};

export default budgetApi;
